export default {
    search(data) {
        return axios.post('/frontend/quote/search', data)
    }
}
